import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
  Authorization: localStorage.getItem('authToken') ? `Bearer ${localStorage.getItem('authToken')}` : '',
});

const couponAdminService = {
  getCoupons: async (pageNumber = 1, pageSize = 10, search = '') => {
    let url = `${API_URL}/Spin/Admin/Coupons?Size=${pageSize}&PageNumber=${pageNumber}`;
    if (search) url += `&Search=${encodeURIComponent(search)}`;
    const res = await axios.get(url, { headers: getAuthHeaders() });
    return res.data;
  },
  deleteCoupon: async (id) => {
    const res = await axios.delete(`${API_URL}/Spin/Admin/Coupons/${id}`, { headers: getAuthHeaders() });
    return res.data;
  },
};

export default couponAdminService;
